import React, { Component } from 'react';
import { Route, Router } from 'react-router';

import { setLanguage } from '@eventbrite/i18n';
import { getHistory, updateHistory } from '@eventbrite/react-router-history';

import { OSSLandingPage } from './pages/OSSLandingPage';
import { PageLayout } from './components/PageLayout';

export const PATH_HOME = '/open-source';

export class OpenSourceApp extends Component {
    history;

    constructor(props) {
        super(props);

        setLanguage(props.env.localeInfo.locale);

        // create a history object depending on the environment
        // server-side: dummy/memory history
        // client-side: browser history
        this.history = getHistory();

        // sync the server-side request information w/ the history to make sure
        // we render the correct initial route
        updateHistory(this.history, props.request);
    }

    UNSAFE_componentWillReceiveProps({ request }) {
        // any time we update the App's props after initial render (which really should be never)
        // make sure we also update the history with any changes in the request
        updateHistory(this.history, request);
    }

    render() {
        const serverProps = this.props;
        const withLayout = (Component, componentProps) => (
            <PageLayout {...serverProps}>
                <Component {...componentProps} />
            </PageLayout>
        );

        return (
            <Router history={this.history}>
                <Route
                    path={PATH_HOME}
                    component={(props) => withLayout(OSSLandingPage, props)}
                />
            </Router>
        );
    }
}
